import Detail from "features/Order/Detail";

export default Detail;
